import { ConfigProvider } from 'antd';
import AppLayout from './components/layout/AppLayout';

const App = () => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerHeight: 74,
            footerPadding: '14px 50px'
          },
        },
      }}
    >
      <AppLayout />
    </ConfigProvider>    
  );
}

export default App;